import React,{Component} from 'react'
import './DayItem.css'
import classnames from 'classnames'
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

class DayItem extends Component{
    render(){
        const {item,selectDay,onClick,translate} =this.props
        return(
            <div  className={classnames('day-slide-item', {
                      'day-slide-item-selected': item.period === selectDay,
                  })}
                  onClick={onClick.bind(this,item)}
            >{item.period} {translate(item.periodType)}
            </div>
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(DayItem)


// WEBPACK FOOTER //
// ./src/components/Calculator-board/Day-item/DayItem.js